import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonWithLoader } from 'components/reusable/button-loader';
import { PasswordInput } from 'components/reusable/password-input';
import { setAuthData } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { acceptInvite } from 'store/sagas/sagas';
import { rawParseQuery, transformQueryTypes } from 'utils/url';
const mapData = {
    t: 'string'
};
export const AcceptUserInvite = () => {
    const { dispatch, asyncDispatch } = useGlobalState();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { t: token } = transformQueryTypes(mapData, rawParseQuery());
    const [password, setPassword] = useState('');
    const handleFormSubmit = useCallback((e) => {
        e.preventDefault();
        asyncDispatch(acceptInvite(token, password))
            .then((data) => {
            setLoading(false);
            dispatch(setAuthData(data));
            navigate('/account/jobs');
        })
            .catch(() => {
            setLoading(false);
        });
    }, [asyncDispatch, dispatch, password, token]);
    const handleChangePassword = useCallback((e) => {
        setPassword(e.target.value);
    }, []);
    return (React.createElement("div", { className: "u-align-center" },
        React.createElement("div", { className: "g-page-without-header-footer" },
            React.createElement("div", { className: "u-align-center" },
                React.createElement("div", { className: "logo" },
                    React.createElement("img", { alt: "logo", src: "assets/vouched-logo.svg" }))),
            !token && (React.createElement("div", { className: "u-margin-top-xlarge u-align-center" }, "Invalid token")),
            token && (React.createElement("div", { className: "u-align-horizontal-center u-margin-top-xlarge" },
                React.createElement("form", { autoComplete: "off", className: "g-form", noValidate: true, onSubmit: handleFormSubmit },
                    React.createElement("p", null, "Enter a new password to join Vouched."),
                    React.createElement("div", { className: "u-margin-bottom-medium u-margin-top-xlarge" },
                        React.createElement(PasswordInput, { handleChangePassword: handleChangePassword, invalidData: false, value: password })),
                    React.createElement(ButtonWithLoader, { disabled: !password, isLoading: loading, name: "Accept Invite" })))))));
};
